<template>
  <div>
    <filter-row
      :sync="true"
      range
      @init="filterInit"
      @dishType="type => currentDishType = type"
      @day="date => currentDateDay = date"
      @range="value => currentDateRange = value"
      type="recipes"
    />
    <div v-if="!isLoading && getCurrentGroupedRecipesList.length > 0">
      <!--
      <div
        key="show-boughted-top"
        class="k-purchases__toggle-boughted k-ingredient-card-transition"
        :class="{ active: allIngredientsAreVisible }"
        @click="allIngredientsAreVisible ^= true"
      >{{ !allIngredientsAreVisible ? 'Показать купленные' : 'Скрыть купленные' }}</div>
      -->
      <div v-for="(day, index) in getCurrentGroupedRecipesList" :key="index" class="my-2">
        <p class="mt-3 mb-0" :class="{ 'd-flex align-items-center justify-content-between': $mq === 'xs' || $mq === 'sm' }">
          <span class="k-purchase__title-first mb-1">{{ dateFormat(day[0].date, 'dddd') }}</span>
          <span class="k-purchase__title-additional">{{ dateFormat(day[0].date, 'dd mmmm')}}</span>
        </p>
        <div v-for="(meal, rindex) in getGroupedDayMeals(day)" :key="`r-${rindex}`" class="mb-4">
          <p class="mb-0" v-if="(currentDishType === 'all' && currentTimeType === 'week') || currentTimeType === 'day'">
            <span class="k-purchase__title-second">{{ getMealType(meal[0].meal_type) }}</span>
          </p>

          <div class="d-flex flex-wrap">
            <div
              class="k-menu__dish-card mb-2 h-100"
              v-for="(recipe, recipeIndex) in meal" :key="recipe.shopping_key || `l-${recipeIndex}`"
            >
              <div
                class="k-menu__dish" style="cursor: auto;"
              >
                <div class="k-menu__dish-photo col-4 pl-0" @click="openRecipePurchase(recipe)">
                  <img class="k-menu__dish-img" :src="recipe.cover_url" />
                </div>
                <div class="k-menu__dish-body w-100">
                  <div class="k-menu__dish-description d-flex justify-content-between">
                    <span class="d-flex flex-column" @click="openRecipePurchase(recipe)">
                      {{ recipe.title }}
                    </span>
                    <adaptive-popper height="80" noscrollbar autobox title="Добавить гостя">
                      <template #element>
                        <div class="k-menu__portions mb-3" style="cursor: pointer">
                          <span>{{ recipe.number_of_servings + recipe.guest_count }}</span><br>
                          <span>{{ declOfNum(recipe.number_of_servings + recipe.guest_count, ['порция','порции','порций']) }}</span>
                        </div>
                      </template>
                      <template #content>
                        <div class="d-flex justify-content-center w-100 align-items-center">
                        <span
                            class="circle-button circle-button--red mr-3"
                            @click="changeGuestCount(recipe, -1)"
                        >
                          <svg
                              width="16"
                              height="2"
                              viewBox="0 0 16 2"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                                x="16"
                                y="0.109375"
                                width="1.77778"
                                height="16"
                                rx="0.888889"
                                transform="rotate(90 16 0.109375)"
                                fill="white"
                            />
                          </svg>
                        </span>
                          <span
                              v-if="!needRerender"
                          >{{ recipe.guest_count }} {{ declOfNum(recipe.guest_count, ['гость','гостя','гостей']) }}</span>
                          <span
                              class="circle-button circle-button--green ml-3"
                              @click="changeGuestCount(recipe, 1)"
                          >
                          <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect x="7.11108" width="1.77778" height="16" rx="0.888889" fill="white" />
                            <rect
                                x="16"
                                y="7.10938"
                                width="1.77778"
                                height="16"
                                rx="0.888889"
                                transform="rotate(90 16 7.10938)"
                                fill="white"
                            />
                          </svg>
                        </span>
                        </div>
                      </template>
                    </adaptive-popper>
                  </div>
                  <div class="align-items-center justify-content-between w-100" style="margin-top: 17px; padding: 0 10px 0 45px; display: flex;">

                    <div class="k-article__button-small" @click="navigateToRecipe(recipe)">Открыть рецепт</div>

                    <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        @click="setWillNotCook(recipe)"
                        style="cursor: pointer;"
                    >
                      <path
                          d="M4.8125 19.5625C4.8125 20.6996 5.73787 21.625 6.875 21.625C8.01213 21.625 8.9375 20.6996 8.9375 19.5625C8.9375 18.4254 8.01213 17.5 6.875 17.5C5.73787 17.5 4.8125 18.4254 4.8125 19.5625ZM7.5625 19.5625C7.5625 19.9413 7.25381 20.25 6.875 20.25C6.49619 20.25 6.1875 19.9413 6.1875 19.5625C6.1875 19.1837 6.49619 18.875 6.875 18.875C7.25381 18.875 7.5625 19.1837 7.5625 19.5625Z"
                          :fill="getFillColorByMeal(recipe)"
                      />
                      <path
                          d="M17.1875 19.5625C17.1875 18.4254 16.2621 17.5 15.125 17.5C13.9879 17.5 13.0625 18.4254 13.0625 19.5625C13.0625 20.6996 13.9879 21.625 15.125 21.625C16.2621 21.625 17.1875 20.6996 17.1875 19.5625ZM14.4375 19.5625C14.4375 19.1837 14.7462 18.875 15.125 18.875C15.5038 18.875 15.8125 19.1837 15.8125 19.5625C15.8125 19.9413 15.5038 20.25 15.125 20.25C14.7462 20.25 14.4375 19.9413 14.4375 19.5625Z"
                          :fill="getFillColorByMeal(recipe)"
                      />
                      <path
                          d="M2.81875 3.0625C2.904 3.87444 3.85275 12.8862 3.99919 14.2784C4.10987 15.3309 4.99194 16.125 6.05069 16.125H16.764C17.7299 16.125 18.5783 15.4389 18.7811 14.4943L20.4325 6.78806C20.5198 6.37969 20.4194 5.95963 20.1568 5.63581C19.8942 5.31131 19.5044 5.125 19.0871 5.125H4.41856L4.12156 2.3035C4.08444 1.95288 3.7895 1.6875 3.4375 1.6875H1.375C0.9955 1.6875 0.6875 1.9955 0.6875 2.375C0.6875 2.7545 0.9955 3.0625 1.375 3.0625H2.81875ZM19.0871 6.5L17.4364 14.2062C17.3683 14.5211 17.0857 14.75 16.7633 14.75H6.05069C5.69731 14.75 5.40375 14.4853 5.36663 14.1347L4.56294 6.5H19.0871Z"
                          :fill="getFillColorByMeal(recipe)"
                      />
<!--                      <rect-->
<!--                          x="20.7988"-->
<!--                          width="1.5"-->
<!--                          height="28"-->
<!--                          rx="0.75"-->
<!--                          transform="rotate(45 20.7988 0)"-->
<!--                          fill="#A3A3A3"-->
<!--                          v-if="recipe.will_not_cook === 't'"-->
<!--                      />-->
                    </svg>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--
          <div v-else>
            <div v-for="(recipe, recipeIndex) in meal" :key="recipeIndex" class="mb-4">
              <p class="k-purchase__title-description d-flex justify-content-between">
                <span class="d-flex align-items-start mr-4">
                  <span class="cursor-pointer" @click="navigateToRecipe(recipe)">{{ recipe.title }}</span>
                  <adaptive-popper height="80" noscrollbar autobox title="Добавить гостя">
                    <template #element>
                      <span
                        class="k-badge badge k-badge-orange-dark ml-3 cursor-pointer"
                      >{{ recipe.number_of_servings + recipe.guest_count }} {{ declOfNum(recipe.number_of_servings + recipe.guest_count, ['порция','порции','порций']) }}</span>
                    </template>
                    <template #content>
                      <div class="d-flex justify-content-center w-100 align-items-center">
                        <span
                          class="circle-button circle-button--red mr-3"
                          @click="changeGuestCount(recipe, -1)"
                        >
                          <svg
                            width="16"
                            height="2"
                            viewBox="0 0 16 2"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="16"
                              y="0.109375"
                              width="1.77778"
                              height="16"
                              rx="0.888889"
                              transform="rotate(90 16 0.109375)"
                              fill="white"
                            />
                          </svg>
                        </span>
                        <span
                          v-if="!needRerender"
                        >{{ recipe.guest_count }} {{ declOfNum(recipe.guest_count, ['гость','гостя','гостей']) }}</span>
                        <span
                          class="circle-button circle-button--green ml-3"
                          @click="changeGuestCount(recipe, 1)"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect x="7.11108" width="1.77778" height="16" rx="0.888889" fill="white" />
                            <rect
                              x="16"
                              y="7.10938"
                              width="1.77778"
                              height="16"
                              rx="0.888889"
                              transform="rotate(90 16 7.10938)"
                              fill="white"
                            />
                          </svg>
                        </span>
                      </div>
                    </template>
                  </adaptive-popper>
                </span>
                <span
                  class="k-purchases__link-button"
                  v-if="!isAllRecipeIngredientsBought(recipe)"
                  @click="selectAllRecipeIngredients(recipe)"
                >Отметить все элементы</span>
                <span
                  class="k-purchases__link-button"
                  v-else-if="isAllRecipeIngredientsBought(recipe)"
                  @click="selectAllRecipeIngredients(recipe)"
                >Снять все элементы</span>

              </p>
              <transition-group name="list-complete" tag="div" class="k-purchases__content">
                <div v-for="(item, index) in recipe.ingredients" :key="`${index}-${item.id}`" class="k-ingredient-card k-ingredient-card-transition">
                  <purchase-card
                    :item="{...item}"
                    currentTab="recipes"
                    @bought="value => setIsBought(item, value)"
                    :date="recipe.date"
                    v-show="(item.is_bought === 'f' || allIngredientsAreVisible) && item.is_hidden !== 't'"
                  />
                </div>
              </transition-group>
            </div>
          </div>
          -->

        </div>
      </div>

      <!--
      <div
        key="show-boughted"
        class="k-purchases__toggle-boughted k-ingredient-card-transition"
        :class="{ active: allIngredientsAreVisible }"
        @click="allIngredientsAreVisible ^= true"
        v-if="false"
      >{{ !allIngredientsAreVisible ? 'Показать купленные' : 'Скрыть купленные' }}</div>
      -->
    </div>
    <div class="soon-wrapper" v-else-if="!isLoading && !getCurrentGroupedRecipesList.length">
      <p>Нет доступных блюд</p>
    </div>
    <div v-else>
      <k-spinner class="mx-auto" />
    </div>

    <transition name="fade" mode="out-in">
      <purchase-modal
          v-if="showRecipeModal"
          :recipe="currentRecipe"
          @close="showRecipeModal = false"
          :image="$mq === 'sm' || $mq === 'xs'"
      />
    </transition>

<!--    <div :class="{'buy-status': true, 'green': status == 'f', 'red': status == 't'}">-->
<!--      <p v-if="status == 'f'">Добавлено в список покупок</p>-->
<!--      <p v-if="status == 't'">Удалено из списка покупок</p>-->
<!--      <img-->
<!--        src="../../assets/Group302.svg"-->
<!--        alt="avatar"-->
<!--        @click="status = undefined"-->
<!--        v-if="status"-->
<!--      />-->
<!--    </div>-->
  </div>
</template>

<script>
import FilterRow from "../../components/TheFilterRow";
// import PurchaseCard from "../../components/PurchaseCard";
import AdaptivePopper from "../../components/TheAdaptivePropper";
import { getPurchasesListOnDate, setMealData } from "../../api/PurchasesApi";
import { setCookingFor } from '../../api/RecipeApi';
import { groupBy, declOfNum, getMonday } from "../../utils/helper";
import dateFormat from "../../utils/dateformat";
import { mapGetters } from "vuex";
import KSpinner from "../../components/TheSpinner.vue";
import PurchaseModal from './RecipePurchaseModal';

export default {
  components: {
    FilterRow,
    // PurchaseCard,
    AdaptivePopper,
    KSpinner,
    PurchaseModal,
  },
  data: () => ({
    currentDateDay: new Date(),
    currentDateRange: {
      from: getMonday(new Date()),
      to: getMonday(new Date()).setDate(getMonday(new Date()).getDate() + 6)
    },
    currentDishType: "",
    initied: false,
    // allIngredientsAreVisible: false,

    recipesList: [],
    visibleRecipesIds: [],
    dateFormat,
    declOfNum,
    isLoading: false,
    needRerender: false,
    showRecipeModal: false,
    currentRecipe: null,

    mutationPending: false,
    status: undefined,
  }),
  activated() {
    if (this.initied) {
      this.loadRecipes();
    }
  },
  watch: {
    async currentDateRange() {
      await this.loadRecipes();
    },
    async currentTimeType() {
      await this.$nextTick();
      await this.loadRecipes();
    },
    async currentDateDay(value) {
      await this.loadRecipes(value);
    }
  },
  computed: {
    ...mapGetters(["getMealReferences", 'getUser', 'getOverload']),
    currentTimeType() {
      return this.getOverload === 'day' ? 'day' : 'week'
    },
    allIngredientsAreVisible: {
      get() {
        return this.$store.getters.getUserSettings.show_boughted_recipes;
      },
      set(value) {
        this.$store.dispatch('updateSettings', {
          show_boughted_recipes: !!value,
        })
      }
    },
    getTransfomedRecipesList() {
      return this.recipesList.map(el => {
        return {
          ...(el.meal || el.set_meal),
          ...el
        };
      }).filter(el => el.will_not_cook !== "t");
    },

    getGroupedByMealTypeRecipesList() {
      return this.getSortedMeals(groupBy(this.getFilteredWeekMeals, 'meal_type'));
    },

    getGroupedByDateRecipesList() {
      return groupBy(this.getFilteredWeekMeals, "date");
    },

    getCurrentGroupedRecipesList() {
      return this.getGroupedByDateRecipesList.slice().sort((a, b) => {
        return new Date(a[0].date) - new Date(b[0].date);
      })
    },

    getFilteredWeekMeals() {
      if (
        this.currentDishType === "all" ||
        !this.getTransfomedRecipesList.length
      ) return this.getTransfomedRecipesList;

      return this.getTransfomedRecipesList.filter(
        el => el.meal_type === this.currentDishType
      );
    },
  },
  methods: {
    async setWillNotCook(recipe) {
      if (this.mutationPending) return;
      this.mutationPending = true;
      const next = recipe.will_not_cook === 't' ? 'f' : 't';
      try {
        const { data } = await setMealData({
          start_date: recipe.date,
          end_date: recipe.date,
          meal_id: recipe.meal && recipe.meal.id,
          set_meal_id: recipe.set_meal && recipe.set_meal.id,
          subscription_id: recipe.subscription_id,
          user_recipe_set_id: recipe.user_recipe_set_id,
          recipe_id: recipe.id,
          will_not_cook: next,
        });
        if (!data || !data.success) return;
        recipe.will_not_cook = next;
        this.$forceUpdate();
        this.status = next;
        await this.loadRecipes();
      } catch (_) {
        // A lost write response is not a confirmed removal. Keep the last confirmed
        // row; a fresh read/retry resolves the result without automatic POST retries.
      } finally {
        this.mutationPending = false;
      }
    },
    openRecipePurchase(recipe) {
      this.currentRecipe = recipe;
      this.showRecipeModal = true;
    },
    getGroupedDayMeals(day) {
      return this.getSortedMeals(groupBy(day, 'meal_type'))
    },
    setIsBought(item, value) {
      this.$set(item, "is_bought", value);
      this.$forceUpdate();
    },
    navigateToRecipe(recipe) {
      if (recipe.recipe_set_id) {
        this.$root.$emit('SHOW_RECIPE', {
          recipe_id: recipe.id,
          set_meal_id: recipe.set_meal.id,
          user_recipe_set_id: recipe.user_recipe_set_id,
          date: recipe.date,
          type: 'special',
          menu: recipe.recipe_set_id,
          is_purchase: true
        })
      } else {
        this.$root.$emit('SHOW_RECIPE', {
          date: recipe.meal.date,
          meal_id: recipe.meal.id,
          subscription_id: recipe.subscription_id,
          recipe_id: recipe.id,
          menu: recipe.menu_id,
          is_purchase: true
        })
      }
    },
    getSortedMeals(source) {
      const sortingArray = Object.keys(this.getMealReferences);

      return source.slice().sort(function(a, b) {
        return (
          sortingArray.indexOf(a[0].meal_type) -
          sortingArray.indexOf(b[0].meal_type)
        );
      });
    },
    getMealType(meal_type) {
      return this.getMealReferences[meal_type];
    },
    getDateForRequest(day) {
      if (day) {
        return {
          start_date: day,
          end_date: day
        }
      } else if (this.currentTimeType === "day") {
        return {
          start_date: this.currentDateDay,
          end_date: this.currentDateDay
        };
      } else {
        return {
          start_date: this.currentDateRange.from,
          end_date: this.currentDateRange.to,
        }
      }
    },
    async changeGuestCount(recipe, value) {
      if (value < 0 && !recipe.guest_count) return;

      const {
        menu_id,
        subscription_id,
        user_recipe_set_id,
        recipe_set_id,
        meal,
        set_meal,
      } = recipe;
      /*
      await setMealData({
        ...this.getDateForRequest(),
        meal_id: recipe.meal && recipe.meal.id,
        set_meal_id: recipe.set_meal && recipe.set_meal.id,
        guest_count: recipe.guest_count + value,
        recipe_id: recipe.id,
      });
      */
     await setCookingFor({
        user_id: this.getUser.id,
        guest_count: recipe.guest_count + value,
        cooking_for: 't',
        meal_id: meal?.id,
        set_meal_id: set_meal?.id,
        menu_id,
        subscription_id,
        user_recipe_set_id,
        recipe_set_id,
        date: meal ? meal.date : set_meal.date,
        recipe_id: recipe.id,
      })

      this.$set(recipe, "guest_count", recipe.guest_count + value);
      this.$forceUpdate();

      this.needRerender = true;
      await this.$nextTick();
      this.needRerender = false;

      await this.loadRecipes();
    },

    hideVisible({ id }) {
      this.visibleRecipesIds = this.visibleRecipesIds.filter(el => el !== id);
    },

    isRecipeBoughtIngredientsVisible({ id }) {
      return this.visibleRecipesIds.some(el => el === id);
    },

    isAllRecipeIngredientsBought(recipe) {
      return recipe.ingredients.every(el => el.is_bought === "t");
    },

    async hideIngredientsInRecipe(recipe) {
      const all_bought = this.isAllRecipeIngredientsBought(recipe);

      await setMealData({
        ...this.getDateForRequest(),
        meal_id: recipe.meal && recipe.meal.id,
        set_meal_id: recipe.set_meal && recipe.set_meal.id,
        is_hidden: all_bought ? "t" : "f"
      });

      // recipe.ingredients = [];
    },

    async selectAllRecipeIngredients(recipe) {
      const is_bought = recipe.ingredients.every(el => el.is_bought === "t")
        ? "f"
        : "t";

      await setMealData({
        ...this.getDateForRequest(),
        meal_id: recipe.meal && recipe.meal.id,
        set_meal_id: recipe.set_meal && recipe.set_meal.id,
        is_bought
      });

      recipe.ingredients = recipe.ingredients.map(el => {
        el.is_bought = is_bought;
        return el;
      });
    },

    async filterInit(payload) {
      const { currentDishType, currentDayPicked, currentRangePicked } = payload;

      this.currentDishType = currentDishType;

      this.currentDateDay = currentDayPicked;
      this.currentDateRange = currentRangePicked;

      this.initied = true;

      await this.loadRecipes();
    },

    async loadRecipes(day) {
      if (!this.initied || this.isLoading) return;

      this.isLoading = true;
      const { data } = await getPurchasesListOnDate({
        type: "recipes",
        ...this.getDateForRequest(day),
      });
      this.recipesList = data;
      this.isLoading = false;
    },

    getFillColorByMeal(recipe) {
      if (recipe.will_not_cook === 'f') {
        return '#D51E3A';
      }
      if (recipe.will_not_cook === 't') {
        return '#9DC43B';
      }
      return  '#A3A3A3';
    }
  }
};
</script>

<style lang="scss" scoped>
.k-menu__dish {
  padding: 15px 10px;
}
.k-menu__dish-actions {
  align-items: center;
}
.k-menu__portions {
  font-size: 11px;
  line-height: 1.1;
  text-align: center;
  color: #F68C1E;

  span {
    &:first-child {
      font-size: 17px;
    }
  }
}
@media (max-width: 767.98px) {
  .k-ingredient-card {
    margin-right: 0;
    width: 100%;
  }
  .k-purchase__title-description {
    flex-direction: column;
  }
}


.k-ingredient-card-transition {
  transition: all 0.5s;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active до версии 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
.buy-status {
  position: fixed;
  bottom: -80px;
  right: 20px;
  border-radius: 4px;
  transition: 0.2s linear;
  padding: 16px;
  width: auto;
  min-height: 80px;
  min-width: 300px;
  max-width: 300px;
  display: flex;
  justify-content: space-between;
  // background: #F9FAFB;
  &.green { background: #9DC43B; bottom: 20px; z-index: 1; }
  &.red { background: #C23440; bottom: 20px; z-index: 1; }
  // &.buy-notification {
  //   background-color: black;
  //   // background: #F9FAFB;
  //   // border: 1px solid #666666;
  //   bottom: 20px;
  //   z-index: 1;
  // }
  p {
    align-self: center;
    color: white;
    margin: 0 10px;
  }
  img {
    align-self: flex-start;
    margin-left: 10px;
  }
}
</style>
